import {$qsAll} from '../../@shared/ts/dom';
import {type WCPHPData} from '../../@type/woocommerce/php-data';
import {type IButtonConfigurationOptions, peachpay_initButton, shouldLoadButtonBasedOnAccountSettings, update_buttonIcon} from './button';

declare const peachpay_data: WCPHPData;

declare global {
	interface Window {
		peachpayShortcodeData?: {
			product_id?: string;
		};
	}
}
document.addEventListener('DOMContentLoaded', peachpay_initShortcode);

/**
 * Initializes the peachpay shortcode button.
 */

function peachpay_initShortcode() {
	$qsAll('.pp-button-shortcode').forEach(($shortcode, i: number) => {
		if (!shouldLoadButtonBasedOnAccountSettings()) {
			return;
		}

		$shortcode.setAttribute('data-shortcode-id', String(i));

		const shortcodeInfo: Partial<IButtonConfigurationOptions['shortcodeInfo']> = {
			shortcodeId: i,
			quantity: 1,
		};

		const productId = $shortcode.getAttribute('data-product-id');
		if (productId) {
			shortcodeInfo.productId = Number.parseInt(productId);
		}

		const isElementorSingleProductTemplate = $shortcode.hasAttribute('data-is-elementor-product-page');
		if (isElementorSingleProductTemplate) {
			shortcodeInfo.isElementorSingleProductTemplate = true;
		}

		if (!$shortcode.classList.contains('elementor-pp-button')) {
			update_buttonIcon(peachpay_data.button_icon, 'shortcode', i);
		}

		peachpay_initButton({
			shortcodeInfo: shortcodeInfo as IButtonConfigurationOptions['shortcodeInfo'],
			width: peachpay_data.button_width_product_page,
		});
	});
}

/**
 * Creates a FormData object for a peachpay shortcode button.
 *
 * @param options PeachPay Button options.
 */
export function peachpay_getShortCodeAddToCartFormData(options: IButtonConfigurationOptions) {
	const formData = new FormData();

	if (options.shortcodeInfo) {
		formData.append('add-to-cart', String(options.shortcodeInfo.productId));
		formData.append('quantity', String(options.shortcodeInfo.quantity ?? 1));
	}

	return formData;
}
